
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        constructor()
        {
            super();
        }
        mounted()
        {
            this.$EventBus.Mensajes.SiNoCancelar = this.Abrir;
            this.$EventBus.onKeyDown.subscribe( e =>
            {
                if ( this.Abierto )
                {
                    if ( e.code == 'Enter' || e.key == 's' || e.key == 'S' )
                    {
                        this.Finalizar( 's' );
                    }
                    else if ( e.key == 'n' || e.key == 'N' )
                    {
                        this.Finalizar( 'n' );
                    }
                    else if ( e.code == 'Escape' )
                    {
                        this.Finalizar( 'c' );
                    }
                }
            } );
        }
        public Titulo: string = '';
        public Mensaje: string = '';
        public Si: string = '';
        public No: string = '';

        public MensajeAyuda: string = '';

        public async Abrir( Titulo: string = "", Mensaje: string = "¿Continuar?", Si: string = "Si", No: string = "No", MensajeAyuda: string = "" ): Promise<'s' | 'n' | 'c' >
        {

            this.Cargando = false;
            this.Ayuda = false;

            this.MensajeAyuda = MensajeAyuda;
            this.Titulo = Titulo;
            this.Mensaje = Mensaje;
            this.Si = Si;
            this.No = No;

            this.Abierto = true;

            await new Promise( ( resolve ) =>
            {
                const resolver = () => { resolve(); this.$off( 'yesno-finished', resolver ); };
                this.$on( 'yesno-finished', resolver );
            } );

            this.Abierto = false;
            return this.Resultado;
        }

        public async Finalizar( b: 's' | 'n' | 'c'  )
        {
            this.Resultado = b;
            this.$emit( 'yesno-finished' );
        }

        public Cargando: boolean = false;
        public Abierto: boolean = false;
        public Resultado: 's' | 'n' | 'c' = 'c';
        public MouseOver: boolean = false;
        public Ayuda: boolean = false;
    }
